export const state = {
    crmProposta: {},
    crmPropostas: [],
    modalExcluirCrmProposta: false,
    modalCadastroCrmProposta: false,
    modalVisualizarCrmProposta: false,
    modalFinalizarCrmProposta: false,
    crmPropostaStatus: [
        'EM ABERTO',
        'EM ANDAMENTO',
        'AGUARDANDO RETORNO DO CLIENTE',
        'CANCELADA',
        'CONVERTIDA EM VENDA',
    ]
}

export default {}